import {Injectable} from '@angular/core';
import {HateoasBaseService} from './hateoas-base.service';
import {HttpUtil} from '../utils/http-util';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {TrackerFilePaginatedModel} from '../models/tracker-file-paginated-model';
import {PageEvent} from '@angular/material/paginator';
import {TrackerFileFilter} from '../pages/tracker-file/tracker-file-filter';
import {TrackerFileModel} from '../models/tracker-file-model';
import {TrackerModel} from '../models/tracker-model';
import {TrackerFileSourceEventResponse} from '../models/tracker-file-source-event-response.model';
import {HttpParams} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TrackerFileService extends HateoasBaseService {

  // tslint:disable-next-line:variable-name
  private _httpUtil: HttpUtil;
  // tslint:disable-next-line:variable-name
  private _http: HttpClient;
  private resourceName = 'tracker-files';

  constructor(http: HttpClient,
              httpUtil: HttpUtil) {
    super(http, httpUtil);
    this._httpUtil = httpUtil;
    this._http = http;
  }

  public getPaginated(page: PageEvent, direction: string, filter: TrackerFileFilter): Observable<TrackerFilePaginatedModel> {
    const params = this._httpUtil.buildPaginator(page, direction);
    if (filter) {
      if ( filter.terminalId && filter.terminalId > 0) {
        params.set('terminalId', filter.terminalId.toString());
      }
      if ( filter.initialDate ) {
        params.set('initialDate', this.convertUTCtoLocal(filter.initialDate));
      }
      if ( filter.finalDate ) {
        params.set('finalDate', this.convertUTCtoLocal(filter.finalDate));
      }
      if (filter.fileType !== undefined && filter.fileType !== null && filter.fileType !== 'BOTH'){
        params.set('fileType', filter.fileType);
      }
      if (filter.sourceDevice !== undefined && filter.sourceDevice !== null && filter.sourceDevice !== 'BOTH'){
        params.set('sourceDevice', filter.sourceDevice);
      }
      if (filter.sourceEvents !== undefined && filter.sourceEvents !== null && filter.sourceEvents.length > 0){
        params.set('sourceEvents', filter.sourceEvents.join(','));
      }

    }

    return this.executeActionOnResource(this.resourceName, 'get-all', null, null, params);
  }

  public getLink(trackerFile: TrackerFileModel): Observable<TrackerModel> {
    return this.executeActionOnResource(this.resourceName, 'get-link', trackerFile, null, null);
  }

  /**
   * Busca todos os eventos disponíveis do tracker file
   * @returns Observable com lista de eventos
   */
  public getTrackerFileSourceEvents(): Observable<TrackerFileSourceEventResponse[]> {
    return this.executeActionOnResource(this.resourceName, 'get-tracker-file-source-events', null, null, null);
  }

  /**
   * Chama o endpoint de relatórios agregados por terminais e período
   * Todos os parâmetros são enviados como string.
   */
  public getReportsFiles(initialDate: string, finalDate: string, terminalIdsCsv: string, sourceEvents?: string): Observable<any[]> {
    const params = new Map<string, string>();
    params.set('initialDate', initialDate || '');
    params.set('finalDate', finalDate || '');
    params.set('terminalIds', terminalIdsCsv || '');
    if (sourceEvents) {
      params.set('sourceEvents', sourceEvents);
    }
    return this.executeActionOnResource(this.resourceName, 'get-reports-files', null, null, params);
  }

  protected getApiBaseUrl(): string {
    return environment.apisConfig.seteraTrackingHardwareApi.apiBaseUrl;
  }

  protected getMicroServiceBaseUrl(): string {
    return environment.apisConfig.seteraTrackingHardwareApi.microServiceBaseUrl;
  }

  convertUTCtoLocal(utcDate: Date): string {
    const tzoffset = utcDate.getTimezoneOffset() * 60000; //offset in milliseconds
    return new Date(utcDate.valueOf() - tzoffset)
        .toISOString()
        .slice(0, -1);
  }
}
